import { BaseModel } from './basemodel';

export enum WorkerStatus {
  ACTIVE = 'ACTIVE',
  PAIRED = 'PAIRED',
  NOT_PAIRED = 'NOT_PAIRED',
}

export interface Worker extends BaseModel {
  created_at: string;

  email: string;

  given_name?: string;

  family_name?: string;

  status: WorkerStatus;

  assignedWorkflowId?: string;

  assignedIdleWorkflowId?: string;

  pairedHandheldCount: number;

  additionalData?: string;

  usesDraftWorkflowDefinition: boolean;
  
  shouldUpdateDeviceOrganization?: boolean;
}
